<template>
  <div>
    <ul>
      <li v-for="(item, idx) in items" :key="item.id">
        <span @click="onClickOnDelete(idx)" class="canvas-item-list__item-label">
          {{item.label}}
          <i class="material-icons">delete_outline</i>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { MDCMenu } from "@material/menu";

export default {
  name: "bmcanvas-item-list",
  props: ["items"],
  mounted() {
    //this.menu = new MDCMenu(this.$el.querySelector(".mdc-menu"));
  },
  data() {
    return {
      menu: null
    };
  },
  methods: {
    onClickOnDelete(index) {
      this.$emit("onDelete", index);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
ul {
  float: none;
  margin: 0;
  padding: 0;
  list-style-type: none;
  li {
    display: inline-block;
  }
  .canvas-item-list__item-label {
    position: relative;
    display: block;
    background: rgba(251, 184, 41, 0.3);
    border-radius: 5px;
    padding: 10px;
    margin: 5px;
    i {
      display: none;
      font-size: 20px;
      position: absolute;
      top: -8px;
      right: -8px;
      color: rgba(255, 0, 0, 0.8);
    }
    &:hover {
      cursor:pointer;
      background: rgba(255, 0, 0, 0.8);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CanvasItemList.vue